<template>
  <div class="h-full bg-base-200 dark:bg-neutral overflow-y-auto scrollbar-thin mt-4">


    <!-- Search Box -->
    <div class="px-3 py-3">
      <div class="form-control relative">
        <input type="text" placeholder="Search" class="input input-sm input-bordered w-full pr-8" />
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 absolute right-3 top-2.5 opacity-70" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
    </div>


    <!-- Main Menu -->
    <div class="px-3 py-2">
      <ul class="menu menu-sm w-full rounded-box">
        <li class="menu-title text-xs font-medium opacity-70">Yönetim</li>
        <li>
          <router-link to="/options" class="flex items-center rounded-lg py-2 group" :class="{'active': route.path === '/options'}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
            </svg>
            Home
          </router-link>
        </li>
        <li>
          <router-link to="/tasks" class="flex items-center rounded-lg py-2 group" :class="{'active': route.path.includes('/tasks')}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
            </svg>
            Tasks
            <!-- <span class="badge badge-primary badge-sm ml-auto">8</span> -->
          </router-link>
        </li>
        <li>
          <router-link to="/kanban" class="flex items-center rounded-lg py-2 group" :class="{'active': route.path.includes('/kanban')}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" />
            </svg>
            Kanban
          </router-link>
        </li>
        <li>
          <router-link to="/calendar" class="flex items-center rounded-lg py-2 group" :class="{'active': route.path.includes('/calendar')}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 9v7.5" />
            </svg>
            Calendar
          </router-link>
        </li>
        <li>
          <router-link to="/slider/list" class="flex items-center rounded-lg py-2 group" :class="{'active': route.path.includes('/slider')}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 9v7.5" />
            </svg>  
            Slider
          </router-link>
        </li>
        <li>
          <router-link to="/sinif/list" class="flex items-center rounded-lg py-2 group" :class="{'active': route.path.includes('/sinif')}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 9v7.5" />
            </svg>  
            Sınıflar
          </router-link>
        </li>



        <div class="divider my-2"></div>
        
        <!-- Management Section -->
        <li class="menu-title text-xs font-medium opacity-70">Management</li>
        <li>
          <router-link to="/users/list" class="flex items-center rounded-lg py-2 group" :class="{'active': route.path.includes('/users')}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
            </svg>
            Users
          </router-link>
        </li>
        <li>
          <router-link to="/contacts" class="flex items-center rounded-lg py-2 group" :class="{'active': route.path.includes('/contacts')}">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 group-hover:text-primary transition-colors">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
            </svg>
            Contacts
          </router-link>
        </li>


        <div class="divider my-2"></div>

        <li class="menu-title text-xs font-medium opacity-70">Servisler</li>
        <li v-for="service in getServices" :key="service.id">
          <a
          target="_blank" 
          :href="`${service.loginUrl}firebase/?token=${idToken}`" 
          class="flex items-center rounded-lg py-2 group">
            {{ service.name }}
          </a>
        </li> 

      </ul>
    </div>


  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute } from "vue-router";
const route = useRoute();


import Services from '@/data/services.json';
import ServicesHost from '@/data/services-host.json';
import ServicesFenOgren from '@/data/services-fenogren.json';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const idToken = ref(null);
const user = ref(null);
const auth = getAuth();

const getServices = computed(() => {
  if (import.meta.env.VITE_SERVICES === 'local') {
    return Services;
  } else {
    if (import.meta.env.VITE_SITE === 'fenogren') {
      return ServicesFenOgren;
    } else {
      return ServicesHost;
    }
  }
});

const kazanimService = computed(() => {
  return getServices.value.find(service => service.id === 'dersapp-kazanim');
});

const tahtaService = computed(() => {
  return getServices.value.find(service => service.id === 'dersapp-tahta');
});


const bookswapService = computed(() => {
  return getServices.value.find(service => service.id === 'dersapp-bookswap');
});

const simulationService = computed(() => {
  return getServices.value.find(service => service.id === 'dersapp-simulation');
});



onMounted(() => {
  onAuthStateChanged(auth, (currentUser) => {
    if (currentUser) {
      user.value = currentUser;

      // Get the ID token from the authenticated user
      currentUser.getIdToken(true).then((token) => {
        idToken.value = token;
      });
      
      // Fetch custom token using the new approach with ID token authorization

    }
  });
});


</script>
